import React from "react";
import { Row, Col } from "antd";
import { useAppContext } from "../../../context/AppContext";
import OutboundCard from "./outboundCard";
import FullPlanComparison from "./fullPlanComparison";
import { updateOutbound } from "../../../actions/appActions";
import OutboundPlanComparison from "./outboundPlanComparison";
import ContactSalesCard from "./contactSalesCard";
import { EMAIL_RANGE_LIMIT } from "../../../utils/constants";

const OutboundCardsContainer = props => {
    const {
        state: { outbound },
        dispatch,
    } = useAppContext();
    const { plans } = props;
    if (!plans) return null;

    const handleClick = plan => {
        const { planHandle, includedEmails } = plan;
        dispatch(updateOutbound({ planHandle: planHandle, allocation: includedEmails }));
    };
    return (
        <div style={{ margin: "2rem 0" }}>
            <Row type="flex" justify="center" gutter={16}>
                {plans.map((plan, key) => (
                    <Col
                        xs={24}
                        sm={12}
                        xl={6}
                        style={{ marginBottom: "1rem", maxWidth: "300px", minWidth: "260px" }}
                        key={key}
                    >
                        <OutboundCard
                            outboundPlan={plan}
                            highlighted={plan.planHandle === outbound.planHandle}
                            handleClick={() => handleClick(plan)}
                        />
                    </Col>
                ))}
                <Col
                    xs={24}
                    sm={12}
                    xl={6}
                    style={{ marginBottom: "1rem", maxWidth: "320px", minWidth: "260px" }}
                    key={"outbound-contact-sales"}
                >
                    <ContactSalesCard highlighted={outbound.allocation === EMAIL_RANGE_LIMIT} />
                </Col>
            </Row>
            {/* Just hiding this for now since it isn't adding any new information*/}
            {false && (
                <FullPlanComparison
                    buttonText={`See Full Outbound Plan Comparison`}
                    title={`Outbound Filtering Plans Comparison`}
                >
                    <OutboundPlanComparison plans={plans} />
                </FullPlanComparison>
            )}
        </div>
    );
};

export default OutboundCardsContainer;
